import _extends from '@babel/runtime/helpers/extends';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classnames from 'classnames';
import React__default, { useState, useEffect } from 'react';
import alertUserOfDeprecatedProps from '../../utils/deprecation.js';
import useCanvasId from '../../utils/useCanvasId.js';
import InputChip from './Chip.js';

var _excluded = ["className", "id", "data-testid", "defaultValue", "disabled", "name", "onChange", "onUpdate", "options", "optionsProps", "required", "singleSelect", "size", "value", "error"];
var InputChips = function InputChips(props) {
  var className = props.className,
    id = props.id,
    dataTestId = props['data-testid'],
    defaultValue = props.defaultValue,
    disabled = props.disabled,
    name = props.name,
    onChange = props.onChange,
    onUpdate = props.onUpdate,
    options = props.options,
    optionsProps = props.optionsProps,
    _props$required = props.required,
    required = _props$required === void 0 ? false : _props$required,
    _props$singleSelect = props.singleSelect,
    singleSelect = _props$singleSelect === void 0 ? false : _props$singleSelect,
    _props$size = props.size,
    size = _props$size === void 0 ? 'normal' : _props$size,
    initValue = props.value;
    props.error;
    var otherProps = _objectWithoutProperties(props, _excluded);
  var _useState = useState(initValue || defaultValue || (singleSelect ? null : [])),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  alertUserOfDeprecatedProps('InputChips', otherProps);
  var uuid = useCanvasId(id, 'Chips');
  if (onChange) {
    console.error("Hey Canvas User! This component does not support onChange. Please use onUpdate(id, value) instead.");
  }
  useEffect(function () {
    // only run if there is a passed value and if the passed value does not equal the current value
    if (value !== initValue) {
      setValue(initValue || defaultValue || (singleSelect ? null : []));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initValue, defaultValue]);
  var handleOnChange = function handleOnChange(chipValue) {
    return function (event) {
      if (singleSelect) {
        if (value === chipValue) {
          setValue(null);
          onUpdate && onUpdate(name || id, null);
        } else {
          setValue(chipValue);
          onUpdate && onUpdate(name || id, chipValue);
        }
        return;
      }
      var nextValue = initValue || value;
      if (event.target.checked && nextValue.indexOf(chipValue) === -1) {
        nextValue = nextValue.concat(chipValue);
      } else if (nextValue.indexOf(chipValue) !== -1) {
        var index = nextValue.indexOf(chipValue);
        nextValue = [].concat(_toConsumableArray(nextValue.slice(0, index)), _toConsumableArray(nextValue.slice(index + 1)));
      } else {
        return;
      }
      setValue(nextValue);
      onUpdate && onUpdate(name || id, nextValue);
    };
  };
  var isChipActive = function isChipActive(chipValue, propsValue, isSingleSelect) {
    var currentValue = propsValue || value;
    if (isSingleSelect) {
      return chipValue === currentValue;
    } else {
      return currentValue.indexOf(chipValue) !== -1;
    }
  };
  var finalClasses = classnames('C-InputChips', className);
  return /*#__PURE__*/React__default.createElement("fieldset", _extends({
    "data-testid": dataTestId,
    className: finalClasses
  }, otherProps), /*#__PURE__*/React__default.createElement("legend", {
    className: "hc-sr-only"
  }, "Group of ".concat(options.length, " selectable chips. ").concat(required && !singleSelect ? 'You must select at least one option.' : '', " ").concat(required && singleSelect ? 'You must select one option.' : '')), options.map(function (option, index) {
    return /*#__PURE__*/React__default.createElement(InputChip, _extends({
      "data-testid": dataTestId ? "".concat(dataTestId, "_").concat(option.value) : null,
      disabled: option.disabled || disabled,
      highlight: option.highlight,
      id: id ? "".concat(id, "_").concat(index) : "".concat(uuid, "_").concat(index),
      key: "".concat(id, "_").concat(index),
      label: option.label,
      onChange: handleOnChange(option.value),
      checked: isChipActive(option.value, value, singleSelect),
      size: size,
      value: option.value
    }, optionsProps));
  }));
};
InputChips.displayName = 'Input.Chips';

export { InputChips as default };
